export default __webpack_public_path__ + "static/media/AGL.204d77a1.png";